import {AbstractValidatable, ValidationErrorsObject} from "frontend-core";
import {ISegmentDto, SegmentRule} from "@/modules/Segmentation/models/SegmentRule";
import {AntiSegmentRule, IAntiSegmentDto} from "@/modules/Segmentation/models/AntiSegmentRule";
import {ISegmentationImageAgentDto} from "@/modules/Segmentation/models/SegmentationImage";

export class SegmentationTarget extends AbstractValidatable {
    public errors: ValidationErrorsObject<{
        rules: string[],
    }>;
    public readonly id: string;
    public readonly agentId: string;
    public readonly segments: SegmentRule[];
    public readonly antiSegments: AntiSegmentRule[];
    public readonly parentId: string | null;

    constructor(dto?: ISegmentationTargetDTO | ISegmentationSlimDTO)
    constructor(
        segments?: SegmentRule[],
        antiSegments?: AntiSegmentRule[],
        id?: string,
        agentId?: string,
        parentId?: string | null,
    )
    constructor(
        segmentsOrDTO: SegmentRule[] | ISegmentationSlimDTO | ISegmentationTargetDTO = [],
        antiSegments: AntiSegmentRule[] = [],
        id: string = "",
        agentId: string = "",
        parentId: string | null = null,
    ) {
        super();

        if (!Array.isArray(segmentsOrDTO)) {
            if (SegmentationTarget.isFullDto(segmentsOrDTO)) {
                this.segments = segmentsOrDTO.segments.map(i => new SegmentRule(i));
                this.antiSegments = segmentsOrDTO.antiSegments.map(i => new AntiSegmentRule(i));
            } else {
                this.segments = [];
                this.antiSegments = [];
            }

            this.id = segmentsOrDTO.id;
            this.agentId = segmentsOrDTO.agent.id;
            this.parentId = segmentsOrDTO.parent;
        } else {
            this.segments = segmentsOrDTO;
            this.antiSegments = antiSegments;
            this.id = id;
            this.agentId = agentId;
            this.parentId = parentId;
        }

        this.errors = {
            rules: [],
        };
    }

    static isFullDto(dto: ISegmentationSlimDTO | ISegmentationTargetDTO): dto is ISegmentationTargetDTO {
        return dto.hasOwnProperty("segments");
    }
}

export type ISegmentationSlimDTO = Readonly<{
    "id": string,

    "agent": ISegmentationImageAgentDto,

    /**
     * @description Если наследует сегментацию, то есть ссылка на родителя { ISegmentationTargetDTO }
     */
    "parent": string | null;
}>;


export type ISegmentationTargetDTO = ISegmentationSlimDTO & Readonly<{
    /**
     * @description может быть пустым, если наследуется от родителей
     * елементы массива - результаты Json.stringify
     */
    "segments": ISegmentDto[];

    /**
     * @description может быть пустым, если наследуется от родителей
     * елементы массива - результаты Json.stringify
     */
    "antiSegments": IAntiSegmentDto[];
}>;
